import { Component, inject, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ManageBriefTabsService } from '../../../../service/manage-brief-tabs/manage-brief-tabs.service';
import { FormatService } from '../../../../../../common/format/format.service';
import { LatestPostResultsDto } from '../../../../../../common/general-types/super-social.dto';

@Component({
  selector: 'mbtr-stats-overview',
  standalone: true,
  imports: [],
  templateUrl: './stats-overview.component.html',
  styleUrl: './stats-overview.component.css'
})
export class StatsOverviewComponent implements OnInit, OnChanges {

  @Input() postsList: LatestPostResultsDto[] | undefined;

  totalViews: number = 0;
  totalLikes: number = 0;
  totalShares: number = 0;
  totalComments: number = 0;
  totalSaves: number = 0;
  totalAudience: number = 0;
  totalPosts: number = 0;
  totalEngagements: number = 0;
  totalInteractions: number = 0;


  /** Services */
  public manageBriefTabsService = inject(ManageBriefTabsService);
  public formatService = inject(FormatService);
  /** Services - END */

  ngOnInit(): void {
    this.tallyOverviewResults();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['postsList']) {
      this.tallyOverviewResults();
    }
  }

  tallyOverviewResults() {
    this.totalViews = 0;
    this.totalLikes = 0;
    this.totalShares = 0;
    this.totalComments = 0;
    this.totalSaves = 0;
    this.totalAudience = 0;
    this.totalPosts = 0;
    this.totalEngagements = 0;

    if (this.postsList) {

      Object.keys(this.postsList).forEach((key: any) => {
        this.totalViews += this.postsList![key].views;
        this.totalLikes += this.postsList![key].likes;
        this.totalShares += this.postsList![key].shares;
        this.totalSaves += this.postsList![key].save_count;
        this.totalComments += this.postsList![key].comments;
        this.totalAudience += this.postsList![key].followers;
        this.totalPosts += Number(1);
      });
     

      this.totalEngagements = this.totalComments + this.totalLikes + this.totalSaves + this.totalShares;
    }

  }
  
}
